export default {
    modalQuickActionVariations: {
        title: 'IA ',
        generateWithAi: 'Gerar com IA',
        improveWriting: 'Melhorar a escrita',
        fixSpelling: 'Corrigir ortografia e gramática',
        simplifyWriting: 'Simplificar a escrita',
        makeLonger: 'Aumentar',
        makeShorter: 'Encurtar',
        replaceText: 'Substituir Texto',
        addBelow: 'Adicionar abaixo',
        cancel: 'Cancelar',
        selectQuickActionTitle: 'Diga à IA o que fazer a seguir...',
        regenerate: 'Regenerar',
    },
};
